<template>
  <div class="questions_content">
    <Q_AVue />
  </div>
</template>
<script>
import Q_AVue from "./Q&A/Q_A.vue";

export default {
  components: {
    Q_AVue,
  },
};
</script>
<style scoped>
.questions_content{
    overflow: auto;
    height: 100%;
    width: 100%;
}
</style>
